import React, { Component } from 'react';
import '../Assets/Styles/loader.css';

class Loader extends Component {
    render() {
        return (
            <div className={`loader-container ${this.props.position && this.props.position === 'start' ? 'flexStart' : ''}`}>
                <div className="loader" style={{ transform: `scale(${this.props.scale})` }}>
                    <div /><div /><div /><div />
                </div>
            </div>
        );
    }
}

export default Loader;
